module.exports = __webpack_public_path__ + "img/frame (31).1eedaf4b.jpg";